export default __webpack_public_path__ + "static/media/astitva-1.a8d2c407.png";